<nb-card>
  <nb-card-header class="main-header">
    Teams in diesem Bereich
  </nb-card-header>

  <nb-card-body>
    <div class="team-grid" *ngIf="teams.length > 0; else noTeams">
      <nb-card *ngFor="let team of teams" class="team-card" [style.borderTopColor]="team.color">
        <nb-card-header>
          <div class="card-header">
            <span class="team-name">{{ team.name }}</span>
            <span class="team-abbreviation">({{ team.abbreviation }})</span>
          </div>
        </nb-card-header>

        <nb-card-body>
          <div><strong>Leitung:</strong> {{ team.leader.fullName }}</div>
          <div><strong>Mitglieder:</strong> {{ team.userCount }}</div>
          <div><strong>Fläche:</strong> {{ team.totalArea | number:'1.2-2' }} m²</div>
          <div><strong>Gebäude:</strong> {{ team.buildingCount }}</div>
          <div><strong>Dienstleister:</strong> {{ team.tenant.name }}</div>
        </nb-card-body>

        <nb-card-footer>
          <button nbButton size="small" status="basic" (click)="goToTeam(team)">Details</button>
        </nb-card-footer>
      </nb-card>
    </div>

    <ng-template #noTeams>
      <div class="no-teams-message">Keine Teams in dieser Region vorhanden.</div>
    </ng-template>
  </nb-card-body>
</nb-card>
